import React from 'react';
import './Foodtransport.css';
import FMSimage from '../Assets/foodtransport1.jpg'; // First image (full size)
import FMSimage2 from '../Assets/foodtransport2 (1).jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/foodtransport3.jpeg'; // Image for How it Works section
import FMSimage4 from '../Assets/foodtransport4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/foodtransport5.jpg'; // Image for Industries section

const Foodtransport = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">Telematics For Food and Transport</h1>
                    <p className="FMS-description">
                        Temperature Monitoring systems ensure real-time tracking of temperature levels in trucks transporting perishable goods. These systems utilize wireless sensors to provide continuous monitoring, ensuring that goods remain within the required temperature range and alerting users in case of deviations.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Temperature Monitoring" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Temperature Monitoring system ensures accurate tracking of temperature variations, preventing spoilage and ensuring compliance with safety regulations. Key features include real-time monitoring, wireless data transmission, and automated alerts.
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        The system continuously monitors temperature levels using RF sensors. If the temperature deviates from the predefined range, an alert is triggered, notifying the user via a mobile app or monitoring system, ensuring the safety of perishable goods.
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Temperature Monitoring System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Temperature Monitoring system ensures reliable tracking with advanced features such as:
                        <ul>
                            <li>Real-time temperature tracking</li>
                            <li>Automated alerts for temperature deviations</li>
                            <li>Wireless data transmission and cloud storage</li>
                            <li>Customizable threshold settings</li>
                            <li>Seamless integration with fleet management systems</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our Temperature Monitoring System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using Temperature Monitoring System" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Temperature Monitoring system is widely used across various industries to ensure the safety and quality of temperature-sensitive goods. Industries benefiting from this solution include:
                        <ul>
                            <li>Cold Chain Logistics & Transportation</li>
                            <li>Food & Beverage Industry</li>
                            <li>Pharmaceuticals & Healthcare</li>
                            <li>Agriculture & Dairy Products</li>
                            <li>Warehousing & Storage Facilities</li>
                            <li>Retail & Supermarkets</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Foodtransport;
